import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { StateWithWishlist, WishlistState } from '../wishlist-state';
import { getWishlistState } from './state.selectors';

const getWishlistEntryListState: MemoizedSelector<
  StateWithWishlist,
  StateUtils.LoaderState<WishlistEntry[]>
> = createSelector(getWishlistState, (state: WishlistState) => state.entryList);

export const getWishlistEntryListInitial: MemoizedSelector<StateWithWishlist, boolean> = createSelector(
  getWishlistEntryListState,
  (state: StateUtils.LoaderState<WishlistEntry[]>) =>
    !StateUtils.loaderLoadingSelector(state) &&
    !StateUtils.loaderSuccessSelector(state) &&
    !StateUtils.loaderErrorSelector(state),
);

export const getWishlistEntryListValue: MemoizedSelector<StateWithWishlist, WishlistEntry[]> = createSelector(
  getWishlistEntryListState,
  (state: StateUtils.LoaderState<WishlistEntry[]>) => StateUtils.loaderValueSelector(state),
);

export const getWishlistEntryListLoading: MemoizedSelector<StateWithWishlist, boolean> = createSelector(
  getWishlistEntryListState,
  (state: StateUtils.LoaderState<WishlistEntry[]>) => StateUtils.loaderLoadingSelector(state),
);

export const getWishlistEntryListError: MemoizedSelector<StateWithWishlist, boolean> = createSelector(
  getWishlistEntryListState,
  (state: StateUtils.LoaderState<WishlistEntry[]>) => StateUtils.loaderErrorSelector(state),
);

export const getWishlistEntryListCount: MemoizedSelector<StateWithWishlist, number> = createSelector(
  getWishlistEntryListValue,
  (entries: WishlistEntry[]) => entries.length,
);

export const hasWishlistEntry = (entry: WishlistEntry): MemoizedSelector<StateWithWishlist, boolean> =>
  createSelector(getWishlistEntryListValue, (entries: WishlistEntry[]) =>
    entries.some((e) => e.productCode === entry.productCode),
  );
